import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminShoppableLandingEdit from "@/pages/admin/AdminShoppableLandingEdit";

export const Route = createFileRoute("/admin/shoppable-landings/$id")({
  component: () => (
    <ProtectedRoute>
      <AdminShoppableLandingEdit />
    </ProtectedRoute>
  ),
});
